const {registerModule, KitModule} = window;

class Video extends KitModule {
  constructor($element) {
    super($element);

    this.setVars();
    this.bindUI();
    this.bindEvents();
    this.initAutoplay();
  }

  /**
   * Autoplay self-hosted video while in view and pause it when scrolled away.
   * Reduced-motion users (or browsers that refuse autoplay) fall back to the click-to-play cover.
   */
  initAutoplay() {
    if (!this.$videoPlayer || !this.$videoPlayer.hasAttribute('data-autoplay')) return;

    // The `muted` attribute alone is unreliable on some browsers for autoplay
    this.$videoPlayer.muted = true;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.showCover();
      return;
    }

    this.autoplayObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // play() rejects when the browser blocks autoplay
          this.$videoPlayer.play().catch(() => {
            this.autoplayObserver.disconnect();
            this.showCover();
          });
        } else {
          this.$videoPlayer.pause();
        }
      });
    }, {threshold: 0.25});
    this.autoplayObserver.observe(this.$element);
  }

  showCover() {
    if (!this.$cover) return;
    this.$cover.hidden = false;
    this.$cover.style.opacity = '';
    this.$cover.style.visibility = '';
    this.$cover.style.pointerEvents = '';
  }

  /**
   * @listens HTMLDialogElement#toggle
   */
  bindEvents() {
    this.$element.addEventListener('click', this);
    if (this.modalId && this.$modal) {
      this.$modal.addEventListener('toggle', this.handleModalToggle.bind(this));
    }
  }

  bindUI() {
    this.$modal = document.getElementById(this.modalId);
  }

  /**
   * Pause the video on modal close
   * @param {ToggleEvent} event
   */
  handleModalToggle(event) {
    if (event.newState === 'closed') {
      const iframe = this.$modal.querySelector('.lite-video iframe');
      const command = {
        method: 'pause',
        value: 'true',
      };
      if (iframe) {
        iframe.contentWindow.postMessage(JSON.stringify(command), '*');
      }
    }
  }

  /**
   * The trigger can be an anchor or button. If anchor, disables normal clicking behavior.
   * @param {Event} event
   */
  onclick(event) {
    if (this.modalId) {
      if (event.target.tagName === 'A' || event.target.closest('a')) {
        event.preventDefault();
      }
    } else {
      const isCoverClick = this.$cover && (event.target === this.$cover || this.$cover.contains(event.target));
      if (isCoverClick) {
        this.$cover.style.opacity = '0';
        this.$cover.style.visibility = 'hidden';
        this.$cover.style.pointerEvents = 'none';
        this.$videoPlayer.play();
      } else if (this.$videoPlayer && !this.$videoPlayer.controls && event.target === this.$videoPlayer) {
        // With native controls hidden, clicking the video is the only pause/resume mechanism
        this.$videoPlayer.paused ? this.$videoPlayer.play() : this.$videoPlayer.pause();
      }
    }
  }

  setVars() {
    this.modalId = this.$element.getAttribute('popovertarget');
  }
}

registerModule('Video', Video);
